import { retryErroredMessagesUrl } from './urls';

import { HsmBackendHttpClient, HsmBackendResponse } from '@/utils/http-client';

/**
 * Requests a retry of the errored (retryable) messages of a finished campaign.
 * Only events in status `error` with a retryable failure code are resent;
 * permanent and ambiguous errors are ignored by the backend.
 *
 * @param websiteId The ID of the website that owns the campaign.
 * @param campaignId The ID of the campaign whose errored messages will be retried.
 * @returns A promise resolving to the backend message describing the result.
 */
export async function retryErroredMessages(
  websiteId: string,
  campaignId: number
): Promise<{ message: string }> {
  const client = HsmBackendHttpClient.instance;

  const response = await client.put<HsmBackendResponse<{ message: string }>>(
    retryErroredMessagesUrl(websiteId, campaignId)
  );

  return response.result;
}
